(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["winter-primary-nav"] && !Shopify.designMode) return;
  try {
    (() => {
    const winterHeaterMenus = document.querySelectorAll('.winter-nav-heaters');
    const winterHeaterDesktop = window.matchMedia('(min-width: 750px) and (hover: hover)');
    const closeDelay = 240;

    winterHeaterMenus.forEach((menu) => {
      const summary = menu.querySelector('.winter-nav-heaters__summary');
      const panel = menu.querySelector('.winter-nav-heaters__panel');
      let closeTimer;

      const syncMenuState = (isOpen) => {
        if (!winterHeaterDesktop.matches) return;
        menu.open = isOpen;
        summary?.setAttribute('aria-expanded', String(isOpen));
      };

      const openMenu = () => {
        window.clearTimeout(closeTimer);
        syncMenuState(true);
      };

      const scheduleClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) {
            syncMenuState(false);
          }
        }, closeDelay);
      };

      const handlePointerLeave = (event) => {
        if (event.relatedTarget instanceof Node && menu.contains(event.relatedTarget)) return;
        scheduleClose();
      };

      menu.addEventListener('pointerenter', openMenu);
      menu.addEventListener('pointerleave', handlePointerLeave);
      panel?.addEventListener('pointerenter', openMenu);
      panel?.addEventListener('pointerleave', handlePointerLeave);
      menu.addEventListener('focusin', () => syncMenuState(true));
      menu.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!menu.contains(document.activeElement)) scheduleClose();
        });
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        window.clearTimeout(closeTimer);
        syncMenuState(false);
        summary?.focus();
      });

      summary?.addEventListener('click', (event) => {
        if (winterHeaterDesktop.matches) {
          event.preventDefault();
          openMenu();
          return;
        }

        window.requestAnimationFrame(() => {
          summary.setAttribute('aria-expanded', String(menu.open));
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
